type LoadingSubscriber = (isLoading: boolean) => void;

class LoadingService {
    private static loadingCount = 0;
    private static subscribers = new Set<LoadingSubscriber>();

    static subscribe(subscriber: LoadingSubscriber) {
        LoadingService.subscribers.add(subscriber);
        subscriber(LoadingService.loadingCount > 0);
    }

    static unsubscribe(subscriber: LoadingSubscriber) {
        LoadingService.subscribers.delete(subscriber);
    }

    static increment() {
        LoadingService.loadingCount += 1;
        LoadingService.notify();
    }

    static decrement() {
        if (LoadingService.loadingCount > 0) {
            LoadingService.loadingCount -= 1;
        }
        LoadingService.notify();
    }

    static reset() {
        LoadingService.loadingCount = 0;
        LoadingService.notify();
    }

    private static notify() {
        const isLoading = LoadingService.loadingCount > 0;
        LoadingService.subscribers.forEach(cb => cb(isLoading));
    }
}

export default LoadingService;
